// extracted by mini-css-extract-plugin
export var active = "Menu-module--active--bLdMz";
export var item = "Menu-module--item--i2edw";
export var link = "Menu-module--link--pvAqj";
export var list = "Menu-module--list--4a49Z";
export var menu = "Menu-module--menu--ETqdK";